__turbopack_context__.v({
  "hide": "Toast-module__gEk-gq__hide",
  "lc-toast-viewport": "Toast-module__gEk-gq__lc-toast-viewport",
  "slideIn": "Toast-module__gEk-gq__slideIn",
  "swipeOut": "Toast-module__gEk-gq__swipeOut",
  "toast-root": "Toast-module__gEk-gq__toast-root",
  "undo-btn": "Toast-module__gEk-gq__undo-btn",
});
